import { render } from "./AddBasedOnButton.vue?vue&type=template&id=685d2eca"
import script from "./AddBasedOnButton.vue?vue&type=script&lang=js"
export * from "./AddBasedOnButton.vue?vue&type=script&lang=js"
script.render = render

export default script